module.exports = __webpack_public_path__ + "static/talent-behind-disney-communications-header-image-749a119cfed3a978b2b88adbec25b7be.jpg";